//
//
//
//
//
//
//
//

import portal from '../../net/portal'
export default {
    props: {
        bdText: {
            type: String
        },
        bdType: {
            type: String,
            default: ''
        },
        bdId: {
            type: String,
            default: ''
        },
        bdDesc: {
            type: String,
            default: ''
        },
        bdPic: {
            type: String
        }
    },
    beforeMount() {
        this.$nextTick(() => {
            this.setup()
        })
    },
    methods: {
        handleShareClick() {
            if (this.bdType && this.bdId) {
                switch (this.bdType) {
                    case 'demand':
                        portal
                            .updateDemandShareNum({
                                query: {
                                    demandId: this.bdId
                                }
                            })
                            .then(() => {})
                        break
                    case 'goods':
                        portal
                            .updateGoodsShareNum({
                                query: {
                                    goodsId: this.bdId
                                }
                            })
                            .then(() => {})
                        break
                    case 'shop':
                        portal
                            .updateShopShareNum({
                                query: {
                                    shopId: this.bdId
                                }
                            })
                            .then(() => {})
                        break
                    default:
                        break
                }
            }
        },
        setup() {
            window._bd_share_config = {
                common: {
                    bdText: this.bdText,
                    bdDesc: this.bdDesc,
                    bdUrl: '',
                    bdPic: this.bdPic
                },
                share: {},
                // image: { //图片分享
                //   viewList: ["qzone", "tsina", "tqq", "weixin"],
                //   viewText: "分享到：", "viewSize": "16"
                // },
                selectShare: {
                    bdContainerClass: null,
                    bdSelectMiniList: ['qzone', 'tsina', 'tqq', 'weixin']
                }
            }
            const s = document.createElement('script')
            s.type = 'text/javascript'
            s.src = '/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5)

            document.body.appendChild(s)
            if (window._bd_share_main) {
                window._bd_share_main.init()
            }
        }
    }
}
